import { render, staticRenderFns } from "./CoverTvForm.vue?vue&type=template&id=458b4b02&"
import script from "./CoverTvForm.vue?vue&type=script&lang=js&"
export * from "./CoverTvForm.vue?vue&type=script&lang=js&"
import style0 from "./CoverTvForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports